import {
  clearAgentSession,
  getAgentSession as getMemoryAgentSession,
  setAgentSession,
  type AgentSession,
} from '../../services/agentSession';

export type { AgentSession } from '../../services/agentSession';

export const getAgentSession = (docId?: string): AgentSession | null => getMemoryAgentSession(docId);

export const storeAgentSession = (token: string, docId: string, expiresIn: number): AgentSession => {
  setAgentSession(docId, token, expiresIn);
  return getMemoryAgentSession(docId)!;
};

export const isUserAuthenticated = (): boolean => getAgentSession() !== null;

export const logout = (): void => {
  clearAgentSession();
  try {
    ['authToken', 'isAuthenticated', 'user-data', 'field-config-cache', 'metro-config-cache', 'lastActivityTs', 'uploadRequiredSectionFieldNames'].forEach(key => localStorage.removeItem(key));
  } catch { /* ignore storage errors */ }
};

export const invalidateAgentSession = logout;

export const getAuthToken = (): string | null => getAgentSession()?.token ?? null;
